
import React from 'react'
import { useTranslation } from 'react-i18next'
import "./KnowEverythingBusiness.scss"

function KnowEverythingBusiness() {
  const { t } = useTranslation()

  return (

    <div className='container-KnowEverythingBusiness'>
      <div className="texts-KnowEverythingBusiness">
        <h1>{t("scheduling.know_everything.title")}</h1>
        <p>{t("scheduling.know_everything.section_text")}</p>
      </div>
    </div>
  )
}


export default KnowEverythingBusiness